export enum HeaderNavigationIcons {
  TRUSTED_DEALER_BADGE = 'trusted_dealer_badge',
}

interface Navigation {
  value: string;
  link: string;
  infoValue: number;
  items: Navigation[];
  icon?: HeaderNavigationIcons;
}

export type GetNavigationResponse = {
  items: Navigation[];
};
